/**
* Behavior to handle UI updates to the FN user profile header drop-down in response to Dalton state
* REFACTORING: taking the existing functionality of the module/nav-pofile.js and tweaking for Dalton
*/

SNI.Application.addBehavior('dalton/nav-profile-fn', (context) => {

  const debug = context.getService('logger').create('behavior.dalton.nav-profile-fn'),
        template = context.getService('template'),
        utils = context.getService('utility'),
        $element = $(context.getElement());

  let defaults = {
    openClass:          'is-Open',
    componentEl:        '.m-NavItemWrap--profile',
    profileButtonSel:   '[data-type="button-header-profile"]',
    profileLink:        '.profile-path',
    profilePageUrl:     '/user-profile-page',
    menu:               '.o-Header__m-DropdownMenu',
    loggedinMenu:       '.logged-in',
    loggedoutMenu:      '.logged-out',
    userLetterSel:      '.user-letter',
    loggedOutClass:     'isLoggedOut',
    loggedInClass:      'isActive',
    avatarSel:          '.user-avatar'
  };

  const config = Object.assign({}, defaults, context.getConfig()),
        $wrapperEl = $element.find(config.componentEl),
        $menu = $wrapperEl.find(config.menu),
        $avatarEl = $wrapperEl.find(config.avatarSel);

  // Registered user avatar (now initial letter, previously UGC image upload)
  let showAvatar = (dta) => {
    $(config.profileButtonSel).find(config.userLetterSel).text(utils.getUserLetter(dta.nickname));
    $(config.profileButtonSel).find(config.avatarSel).removeClass(config.loggedOutClass).addClass(config.loggedInClass);
  };

  // SVG logged-out state for FN header
  let showDefaultAvatar = () => {
    $(config.profileButtonSel).find(config.avatarSel).removeClass(config.loggedInClass).addClass(config.loggedOutClass);
    $(config.profileButtonSel).find(config.userLetterSel).text('');
  };

  // Default user profile menu (logged-out version) --->  <ul class="logged-out"></ul>
  // Registered user profile menu --->  <ul class="logged-in"></ul>
  let hideDefaultMenu = () => {
    if ($menu.find(config.loggedinMenu).length === 0) $menu.append(template.navProfileRegisteredUserMenu);
    $menu.find(config.loggedoutMenu).hide();
    $menu.find(config.loggedinMenu).show();
    // set profile path
    $menu.find(config.profileLink).attr('href', config.profilePageUrl);
  };

  let showDefaultMenu = () => {
    $menu.find(config.loggedinMenu).hide();
    $menu.find(config.loggedoutMenu).show();
  };

  let showRegisteredUserNav = (dta) => {
    showAvatar(dta);
    requestAnimationFrame(hideDefaultMenu);
  };

  let showLoggedOutUserNav = () => {
    requestAnimationFrame(showDefaultAvatar);
    requestAnimationFrame(showDefaultMenu);
  };

  // pending avatar is default (neither logged in nor out)
  let showPendingUserNav = () => {
    $(config.profileButtonSel).find(config.avatarSel).removeClass([config.loggedInClass, config.loggedOutClass]);
  };

  // simulating an enum:
  const UIACTION = Object.freeze({
    LOGGEDIN: 1,
    LOGGEDOUT: 2,
    PENDING: 3,
    getKey: (x) => Object.keys(UIACTION).find(k => UIACTION[k] == x)
  });

  function updateUI(uiAction, dta) {
    debug.log('updateUI', UIACTION.getKey(uiAction));
    switch (uiAction) {
      case UIACTION.LOGGEDIN:
        showRegisteredUserNav(dta);
        break;
      case UIACTION.LOGGEDOUT:
        showLoggedOutUserNav();
        break;
      case UIACTION.PENDING:
        showPendingUserNav();
        break;
    }
  }

  const messageHandlers = {
    'dalton:logged-in': (dta) => {
      debug.log('msg recd: Dalton user is logged in ' + JSON.stringify(dta));
      updateUI(UIACTION.LOGGEDIN, dta);
    },
    'dalton:logged-out': () => {
      debug.log('msg recd: Dalton user is logged out');
      updateUI(UIACTION.LOGGEDOUT);
    },
    'dalton:pending': () => {
      debug.log('msg recd: Dalton response is pending');
      updateUI(UIACTION.PENDING);
    }
  };

  function init() {
    // inserts markup for logged-out state
    debug.log('init');
    if ($menu.find(config.loggedoutMenu).length === 0) $menu.append(template.navProfileDefaultMenu);
  }

  return {

    init,

    messages: Object.keys(messageHandlers),
    onmessage(message, data) {
      messageHandlers[message](data);
    },

  };

});
